<app-page-header [usePreviousPathIfAvailable]="true" />
<app-title-settings />
<app-title-personal-information />
<form [formGroup]="form" (ngSubmit)="save()" class="user-form">
    <div class="form-container">
        <div class="input-fields">
            <app-form-input controlKey="firstName" labelT="users.user-form.first-name" />
            <app-form-input controlKey="lastName" labelT="users.user-form.last-name" />

            <app-form-autocomplete controlKey="organizationUnit" labelT="users.user-form.organization-unit"
                [items]="(filteredOrganizationUnits$ | async)!" [validationRules]="organizationUnitValidationRules" />

            <app-form-input *ngIf="showExternalId" controlKey="externalId" labelT="users.user-form.external-id" />

            <app-form-input controlKey="mobileNumber" labelT="users.user-form.mobile-number"
                [validationRules]="phoneNumberValidationRules" />

            <app-form-input controlKey="mail" labelT="users.user-form.mail" [validationRules]="mailValidationRules" />

            <app-form-datepicker *ngIf="!isInternalUser() && currentUserIsInternal()" controlKey="activeUntil"
                labelT="users.user-form.activeUntil" />

            <app-form-input-readonly labelT="users.user-form.last-activity" [value]="lastSuccessfulLogin" />

            <app-form-input-readonly *ngIf="!isInternalUser()" labelT="users.user-form.created-at"
                [value]="createdAt" />
        </div>
        <div class="toggle-fields">
            <app-form-toggle-user-language controlKey="language" labelT="users.user-form.language"
                class="button-toggle-container" />

            <app-form-toggle-user-status controlKey="active" labelT="users.user-form.active-status"
                class="button-toggle-container" />

            <app-user-picture-editor *ngIf="!isInternalUser()" [isMyProfile]="true" [userId]="currentUserId()"
                [thumbnailPhoto]="thumbnailPhoto" [disabled]="!isActiveUser()" />
        </div>
    </div>

    <mat-divider class="section-divider"></mat-divider>

    <h2>{{ 'users.user-profile.notifications.title' | translate }}</h2>

    <div class="notifications">
        <app-form-toggle controlKey="areMailNotificationsOn"
            labelT="users.user-profile.notifications.mail-notifications" />
        <app-form-select controlKey="notificationInterval" labelT="users.user-profile.notifications.interval.title"
            [items]="intervalOptionsTranslated" class="mt-20" />

    </div>

    <app-user-authentication-editor *ngIf="!isInternalUser()" [userId]="userId"
        [changePasswordUrl]="changePasswordUrl" [showResendWelcomeEmail]="!isInternalUser()" />

    <div class="button-group">
        <app-button-cancel (click)="navigateBack($event)" [disabled]="savePending()" />
        <app-button-save (click)="save()" [disabled]="isInternalUser() || (!form.valid || savePending())" />
    </div>
</form>

<app-user-deputies-editor *ngIf="isInternalUser()" [userId]="userId" [userDeputies]="userDeputies" />

<app-loading-spinner-overlay *ngIf="savePending()"></app-loading-spinner-overlay>